var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21790_23175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21790_23175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21790_23175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99358 14.9027C10.2757 14.9027 10.5232 14.7961 10.7361 14.5829C10.9491 14.3697 11.0557 14.1187 11.0557 13.83C11.0557 13.5412 10.949 13.2948 10.7357 13.0908C10.5225 12.8868 10.2725 12.7848 9.98567 12.7848C9.699 12.7848 9.4515 12.8865 9.24317 13.09C9.03483 13.2936 8.93067 13.5428 8.93067 13.8377C8.93067 14.1218 9.03553 14.3704 9.24525 14.5833C9.45511 14.7962 9.70455 14.9027 9.99358 14.9027ZM10.0057 18.9166C8.7615 18.9166 7.59893 18.6845 6.51796 18.2204C5.43699 17.7564 4.49303 17.1209 3.68608 16.3139C2.87914 15.507 2.24365 14.5634 1.77962 13.4831C1.31546 12.4027 1.08337 11.24 1.08337 9.99496C1.08337 8.74996 1.31546 7.58663 1.77962 6.50496C2.24365 5.42329 2.87837 4.48107 3.68379 3.67829C4.48935 2.87552 5.43261 2.24003 6.51358 1.77184C7.59469 1.3035 8.75817 1.06934 10.004 1.06934C11.2497 1.06934 12.4139 1.30316 13.4967 1.77079C14.5795 2.23829 15.5219 2.87281 16.324 3.67434C17.1259 4.47586 17.7609 5.41836 18.2288 6.50184C18.6967 7.58545 18.9307 8.75024 18.9307 9.99621C18.9307 11.2418 18.6965 12.405 18.2282 13.4858C17.76 14.5666 17.1245 15.5091 16.3217 16.3131C15.5189 17.1171 14.5766 17.752 13.4948 18.2179C12.4129 18.6837 11.2498 18.9166 10.0057 18.9166ZM10.018 6.6735C10.3199 6.6735 10.5857 6.77142 10.8152 6.96725C11.045 7.16295 11.1598 7.40718 11.1598 7.69996C11.1598 7.98607 11.0758 8.24156 10.9077 8.46642C10.7397 8.69114 10.5482 8.88982 10.3334 9.06246C10.0139 9.34024 9.7315 9.64843 9.48608 9.98704C9.2408 10.3258 9.11817 10.6982 9.11817 11.1041C9.11817 11.3101 9.1974 11.4785 9.35587 11.6093C9.51435 11.7402 9.69921 11.8056 9.91046 11.8056C10.1368 11.8056 10.3293 11.7303 10.488 11.5798C10.6464 11.4293 10.7662 11.2477 10.8473 11.0348C10.9121 10.7893 11.0171 10.5693 11.1625 10.3745C11.308 10.1798 11.4817 10.0004 11.6838 9.83621C12.0103 9.56107 12.2766 9.22968 12.4827 8.84204C12.6887 8.4544 12.7917 8.04934 12.7917 7.62684C12.7917 6.90336 12.5301 6.29392 12.0069 5.7985C11.4839 5.30323 10.8653 5.05559 10.1513 5.05559C9.59282 5.05559 9.0715 5.17364 8.58733 5.40975C8.10317 5.64586 7.69907 5.98843 7.37504 6.43746C7.25935 6.61802 7.21379 6.81572 7.23837 7.03059C7.26296 7.24545 7.36622 7.41579 7.54817 7.54163C7.76039 7.67593 7.98448 7.71642 8.22046 7.66309C8.45629 7.60989 8.65365 7.48607 8.81254 7.29163C8.95379 7.11191 9.13018 6.96399 9.34171 6.84788C9.55337 6.73163 9.77879 6.6735 10.018 6.6735Z",
    fill: "#2D3245"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21790_23175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.377c7f2b479f82d739186e7b87a6d82c.svg";
export { ForwardRef as ReactComponent };